<template>
    <v-footer
    height="auto"
    color="primary lighten-1"
    >
    <v-layout
        justify-center
        row
        wrap
    >
      <v-flex
      primary
      lighten-2
      py-3
      text-xs-center
      white--text
      xs12
      >
        Questions or suggestions? Please email us at  <a :href=mail_to>{{mail_link}}</a>.
      </v-flex>
    </v-layout>
    </v-footer>
</template>

<script>
  export default {
    data: () => ({
        mail_link: 'info@predictAAT.us',
        mail_to: 'mailto:info@predictAAT.us'
    })
  }
</script>

<style>

</style>
